import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'

// import styles from './styles.css'
import Icon from '_components/icon'

class CategoryTabIcon extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    selectedTab: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    disabled: false,
  }

  onSelect = () => {
    const { type, onClick, disabled } = this.props
    if (!disabled) onClick(type)
  }

  render() {
    const { type, color, selectedTab, disabled } = this.props
    const isSelected = selectedTab === type
    return (
      <div style={{ flex: 1, marginBottom: 20 }} onClick={this.onSelect}>
        <Icon type={type} color={color} size={60} />
        <div
          style={{
            marginTop: 10,
            fontSize: 12,
            color: isSelected ? 'rgba(255,255,255, 0.8)' : 'rgba(255,255,255, 0.4)',
          }}
        >
          {type.toUpperCase()}
        </div>
      </div>
    )
  }
}

export default CategoryTabIcon



// WEBPACK FOOTER //
// ./src/components/categoryTabs/categoryTabIcon/index.js